// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

import type { ComponentInterface } from '@stencil/core'
import { Component, Element, h } from '@stencil/core'

import type { Attributes } from '../../helpers'
import { inheritAriaAttributes } from '../../helpers'

/**
 * The `<qds-table-row>` element defines a row of cells in a table. The row's
 * cells can then be established using a mix of `<qds-table-cell>` (data cell)
 * and `<qds-table-head-cell>` (header cell) elements.
 *
 * @see https://quartz.se.com/build/components/table
 */
@Component({
  tag: 'qds-table-row',
  shadow: true,
  styleUrl: 'table-row.css',
})
export class TableRow implements ComponentInterface {
  @Element() private readonly host!: HTMLElement

  #inheritedAttributes: Attributes = {}

  public componentWillLoad(): void {
    this.#inheritedAttributes = inheritAriaAttributes(this.host)
  }

  public render() {
    return (
      <tr
        class="qds-table-row"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.#inheritedAttributes}
      >
        <slot />
      </tr>
    )
  }
}
